import { useMemo } from 'react';
import { IS_GLOBAL_CONTEXT_DISABLED, useDesiredChain, useGlobalContextStore, } from './globalContext';
import { currentWallet } from './wallets';
const useIsWrongNetwork = (chainLayer) => {
    const chainId = currentWallet.useChainId();
    const isConnected = currentWallet.useIsConnected();
    const desiredChain = useDesiredChain(chainLayer);
    return isConnected && chainId !== desiredChain;
};
const useIsConnectedToSupportedChain = (chainLayer) => {
    const chainId = currentWallet.useChainId();
    const isConnected = currentWallet.useIsConnected();
    const desiredChain = useDesiredChain(chainLayer);
    return isConnected && chainId === desiredChain;
};
const useAccount = IS_GLOBAL_CONTEXT_DISABLED
    ? currentWallet.useAccount
    : () => {
        const accountFromStore = useGlobalContextStore((s) => s.account);
        const accountFromWallet = currentWallet.useAccount();
        return useMemo(() => {
            if (accountFromStore)
                return accountFromStore;
            return accountFromWallet;
        }, [accountFromStore, accountFromWallet]);
    };
export const currentWalletWithGlobalContext = {
    ...currentWallet,
    // override
    useIsWrongNetwork,
    useIsConnectedToSupportedChain,
    useAccount,
};
